import { type FC } from "react";

import {
  AssistantScope,
  type DocumentFragment,
  type ProjectFragment,
} from "@app_schema";

import { ReportAssistantSplit } from "./assistant/report_assistant_split";
import {
  type DraftingPaneParts,
  FinalReportPane,
  type ReportPaneCopy,
} from "./final_report_pane";

// A report tab (Final Report, Drafting): its upload pane, beside its assistant
// once the assistant is open. `drafting` is the Drafting tab's own parts.
export const ReportSection: FC<{
  project: ProjectFragment;
  scope: AssistantScope.Report | AssistantScope.Drafting;
  agentId?: string;
  documents: DocumentFragment[];
  save: (blob: { signed_id: string }) => Promise<void>;
  available: boolean;
  copy: ReportPaneCopy;
  showAssistant: boolean;
  drafting?: DraftingPaneParts;
}> = ({
  project,
  scope,
  agentId,
  documents,
  save,
  available,
  copy,
  showAssistant,
  drafting,
}) => {
  const pane = (
    <FinalReportPane
      project={project}
      documents={documents}
      save={save}
      available={available}
      copy={copy}
      drafting={drafting}
    />
  );
  if (!showAssistant) return pane;

  return (
    <ReportAssistantSplit
      projectId={project.id}
      scope={scope}
      agentId={agentId}
      available={available}
      files={documents}
      reading={drafting?.reading ?? false}
      uploadPane={pane}
    />
  );
};
